"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var Notifications_1 = require("./../app/Notifications");
var constants_1 = require("./Grid/constants");
var utils_1 = require("./Grid/utils");
var fetch_1 = __importDefault(require("../../utils/fetch"));
var utils_2 = require("../../utils");
var Grid_1 = __importDefault(require("./Grid"));
var url_parse_1 = __importDefault(require("url-parse"));
var getParams = function (_a) {
    var sort = _a.sort, order = _a.order, pageSize = _a.pageSize, page = _a.page, filters = _a.filters, universalFilter = _a.universalFilter, query = _a.query, allowDeleted = _a.allowDeleted, allowDeactivated = _a.allowDeactivated, doPost = _a.doPost, showDeactivated = _a.showDeactivated;
    var filterClean = filters
        .filter(function (_a) {
        var field = _a.field;
        return field !== null;
    })
        .filter(function (_a) {
        var operation = _a.operation;
        return operation !== null;
    })
        .filter(function (_a) {
        var value = _a.value;
        return value !== null;
    })
        .filter(function (_a) {
        var value = _a.value;
        return value !== '';
    })
        .filter(function (_a) {
        var value = _a.value;
        return value !== undefined;
    });
    if (showDeactivated && !allowDeactivated) {
        filterClean.push({
            field: 'active',
            operation: 'EQ',
            value: true,
        });
    }
    var filter = null;
    if (doPost) {
        filter = filterClean.reduce(function (acc, _a, i) {
            var field = _a.field, operation = _a.operation, value = _a.value, aggregation = _a.aggregation;
            var agg = acc.find(function (a) { return a.field === field && a.operation === aggregation; });
            return !aggregation
                ? __spread(acc, [
                    {
                        field: field,
                        operation: operation,
                        value: value,
                    },
                ]) : agg
                ? __spread(acc.filter(function (a) { return !(a.field === field && a.operation === aggregation); }), [
                    __assign({}, agg, { filter: __spread(agg.filter, [
                            {
                                field: field,
                                operation: operation,
                                value: value,
                            },
                        ]) }),
                ]) : __spread(acc, [
                {
                    field: field,
                    operation: aggregation,
                    filter: [
                        {
                            field: field,
                            operation: operation,
                            value: value,
                        },
                    ],
                },
            ]);
        }, []);
    }
    else {
        filter = filterClean.reduce(function (acc, _a, i) {
            var _b;
            var field = _a.field, operation = _a.operation, value = _a.value;
            return (__assign({}, acc, (_b = {}, _b["filter[" + i + "].field"] = field, _b["filter[" + i + "].operation"] = operation, _b["filter[" + i + "].value"] = value, _b)));
        }, {});
    }
    var constructedUniversalFilter = {};
    if (universalFilter) {
        constructedUniversalFilter = doPost
            ? { universalFilter: { value: universalFilter } }
            : { 'universalFilter.value': universalFilter };
    }
    var constructedSort = sort ? { sort: sort, order: order } : undefined;
    return __assign({ pageSize: pageSize,
        page: page }, constructedSort, query, (doPost ? { filter: filter } : filter), constructedUniversalFilter, { allowDeleted: !!allowDeleted });
};
var constructUrl = function (_a) {
    var url = _a.url, sort = _a.sort, order = _a.order, pageSize = _a.pageSize, page = _a.page, filters = _a.filters, universalFilter = _a.universalFilter, query = _a.query, allowDeleted = _a.allowDeleted, allowDeactivated = _a.allowDeactivated, doPost = _a.doPost, showDeactivated = _a.showDeactivated;
    var URLobj = url_parse_1.default(url);
    URLobj.set('query', getParams({
        sort: sort,
        order: order,
        pageSize: pageSize,
        page: page,
        filters: filters,
        universalFilter: universalFilter,
        query: query,
        allowDeleted: allowDeleted,
        allowDeactivated: allowDeactivated,
        doPost: doPost,
        showDeactivated: showDeactivated,
    }));
    return URLobj.toString();
};
var getItems = function (url, _a) { return __awaiter(_this, void 0, void 0, function () {
    var params, postfix, response, response;
    var doPost = _a.doPost, showDeactivated = _a.showDeactivated, allowDeactivated = _a.allowDeactivated, props = __rest(_a, ["doPost", "showDeactivated", "allowDeactivated"]);
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!doPost) return [3 /*break*/, 3];
                params = getParams(__assign({}, props, { doPost: doPost, showDeactivated: showDeactivated, allowDeactivated: allowDeactivated }));
                postfix = '';
                if (showDeactivated) {
                    if (!allowDeactivated) {
                        postfix = '?active=true';
                    }
                    if (!!allowDeactivated) {
                        postfix = '?active=false';
                    }
                }
                return [4 /*yield*/, fetch_1.default(url + "/parametrized" + postfix, {
                        method: 'POST',
                        headers: new Headers({ 'Content-Type': 'application/json' }),
                        body: JSON.stringify(params),
                    })];
            case 1:
                response = _b.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _b.sent()];
            case 3: return [4 /*yield*/, fetch_1.default(url)];
            case 4:
                response = _b.sent();
                return [4 /*yield*/, response.json()];
            case 5: return [2 /*return*/, _b.sent()];
        }
    });
}); };
exports.default = recompose_1.compose(recompose_1.setDisplayName('RemoteGrid'), recompose_1.branch(function (_a) {
    var locale = _a.locale;
    return locale === 'en';
}, recompose_1.defaultProps({
    pageSizeItems: [
        { id: 10, label: '10' },
        { id: 20, label: '20' },
        { id: 50, label: '50' },
        { id: 100, label: '100' },
        { id: 1000, label: '1000' },
        { id: -1, label: 'All' },
    ],
}), recompose_1.defaultProps({
    pageSizeItems: [
        { id: 10, label: '10' },
        { id: 20, label: '20' },
        { id: 50, label: '50' },
        { id: 100, label: '100' },
        { id: 1000, label: '1000' },
        { id: -1, label: 'Vše' },
    ],
})), recompose_1.branch(function (_a) {
    var showNotifications = _a.showNotifications;
    return showNotifications;
}, Notifications_1.withNotifications()), recompose_1.defaultProps({
    sort: null,
    order: constants_1.Order.DESC,
    pageSize: 10,
    page: 0,
    getItems: getItems,
    columns: [],
    filters: [],
    checkedItems: [],
    items: [],
    count: 0,
    openedGroups: [],
    url: null,
    version: null,
    universalFilter: null,
    showError: lodash_1.noop,
    enableUniversalFilter: false,
}), utils_1.persistencePropsLoader, utils_1.gridStateManager, recompose_1.withStateHandlers({ items: [], count: 0, loading: false }, {
    startLoading: function (state) { return function () { return (__assign({}, state, { loading: true })); }; },
    stopLoading: function (state) { return function () { return (__assign({}, state, { loading: false })); }; },
    setItems: function (state) { return function (items, count) { return ({ items: items, count: count }); }; },
}), recompose_1.lifecycle({
    loadData: function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var dirty, url, getItems, doPost, dispatch, loading, startLoading, stopLoading, setItems, showError, url_1, data, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dirty = props.dirty, url = props.url, getItems = props.getItems, doPost = props.doPost, dispatch = props.dispatch, loading = props.loading, startLoading = props.startLoading, stopLoading = props.stopLoading, setItems = props.setItems, showError = props.showError;
                        if (!(dirty && url && !loading)) return [3 /*break*/, 6];
                        // if filter changes, reset page to 0
                        if (!lodash_1.isEqual(props.filters, this.props.filters)) {
                            props = __assign({}, props, { page: 0 });
                        }
                        url_1 = doPost ? props.url : constructUrl(props);
                        startLoading();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, getItems(url_1, props)];
                    case 2:
                        data = _a.sent();
                        if (!this.unmounting) {
                            setItems(data.items, data.count);
                            dispatch(utils_2.createAction('DIRTY', { dirty: false }));
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        showError();
                        return [3 /*break*/, 5];
                    case 4:
                        stopLoading();
                        return [7 /*endfinally*/];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        if (!this.unmounting) {
                            setItems([], 0);
                            dispatch(utils_2.createAction('DIRTY', { dirty: false }));
                        }
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    },
    componentDidMount: function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadData(this.props)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    },
    componentWillReceiveProps: function (newProps) {
        return __awaiter(this, void 0, void 0, function () {
            var name, url, dirty, filters, page, pageSize, universalFilter, sort, order, _a, oldName, oldUrl, oldDirty, oldFilters, oldPage, oldPageSize, oldUniversalFilter, oldSort, oldOrder;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        name = newProps.name, url = newProps.url, dirty = newProps.dirty, filters = newProps.filters, page = newProps.page, pageSize = newProps.pageSize, universalFilter = newProps.universalFilter, sort = newProps.sort, order = newProps.order;
                        _a = this.props, oldName = _a.name, oldUrl = _a.url, oldDirty = _a.dirty, oldFilters = _a.filters, oldPage = _a.page, oldPageSize = _a.pageSize, oldUniversalFilter = _a.universalFilter, oldSort = _a.sort, oldOrder = _a.order;
                        if (!(dirty && dirty !== oldDirty)) return [3 /*break*/, 3];
                        if (!(!lodash_1.isEqual(filters, oldFilters) ||
                            !lodash_1.isEqual(page, oldPage) ||
                            !lodash_1.isEqual(pageSize, oldPageSize) ||
                            !lodash_1.isEqual(universalFilter, oldUniversalFilter) ||
                            !lodash_1.isEqual(sort, oldSort) ||
                            !lodash_1.isEqual(order, oldOrder))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadData(newProps)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        if (!(!lodash_1.isEqual(name, oldName) ||
                            !lodash_1.isEqual(url, oldUrl) ||
                            !lodash_1.isEqual(sort, oldSort) ||
                            !lodash_1.isEqual(order, oldOrder) ||
                            !lodash_1.isEqual(pageSize, oldPageSize))) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.loadData(__assign({}, newProps, { dirty: true }))];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    },
    componentWillUnmount: function () {
        this.unmounting = true;
    },
}))(Grid_1.default);
//# sourceMappingURL=RemoteGrid.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/RemoteGrid.js
// module id = 891
// module chunks = 0